// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__nnT9_","content":"styles_content__LueVW","tableWrap":"styles_tableWrap__yqJOE"};